import { render, staticRenderFns } from "./selectAddress.vue?vue&type=template&id=31ec25b7&scoped=true&"
import script from "./selectAddress.vue?vue&type=script&lang=js&"
export * from "./selectAddress.vue?vue&type=script&lang=js&"
import style0 from "./selectAddress.vue?vue&type=style&index=0&id=31ec25b7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec25b7",
  null
  
)

export default component.exports